export default class SelectedJobsState {
  constructor() {
    if (typeof window.Application.selected_jobs === 'undefined') { // selected_jobs are getting passed in from html.erb
      window.Application.selected_jobs = [];
    }
  }

  selectedJobs() {
    return window.Application.selected_jobs;
  }

  ids() {
    return this.selectedJobs().map(job => parseInt(job.work_item_id));
  }

  ppiItemsOnly() {
    return this.ids().every(id => window.Application.PRE_PURCHASE_INSPECTIONS.indexOf(id) > -1);
  }

  lastAddedJob() {
    return this.selectedJobs().slice(-1)[0] || null;
  }

  add(id, description) {
    window.Application.selected_jobs.push({
      description: description,
      work_item_id: id
    });
  }

  remove(id) {
    window.Application.selected_jobs = this.selectedJobs().filter(job => job.work_item_id != id);
  }

  clear() {
    window.Application.selected_jobs = [];
  }
}
